// Configuración de despliegue (public/config.json): URL del API, isBershka, isV2...
// Se carga una sola vez y queda en window.config. index.js espera a esta carga antes
// de pintar React, así que los componentes pueden leer window.config al renderizar
// sin carreras (antes el login a veces se pintaba sin el carrusel de Bershka).
let cargaConfig = null;

export function loadConfig() {
    if (!cargaConfig) {
        cargaConfig = fetch("/config.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to load config.json");
                }
                return response.json();
            })
            .then((config) => {
                window.config = config;
                return config;
            })
            .catch((error) => {
                // Sin memorizar el fallo: la siguiente llamada vuelve a intentarlo.
                cargaConfig = null;
                throw error;
            });
    }
    return cargaConfig;
}
